/**
 * Strings class for the time off reason type.
 */
export const TimeOffReasonType = {
    Standard: "Standard",
    Custom: "Custom"
};
